export var checkTouchDevice = function () {
    return 'ontouchstart' in window ||
        !!navigator.maxTouchPoints ||
        !!navigator.msMaxTouchPoints;
};
